<div #trigger class="trigger">
  <mat-icon cdkOverlayOrigin svgIcon="ldap" [class.active]="ldapStatus()?.group_dn"/>
</div>

@if (ldapStatus()?.group_dn) {
  <fw-popover [trigger]="trigger" position="below">
    <div class="popover-content">
      <div class="row">
        <h3>LDAP Enabled</h3>
        @if(ldapStatus()?.sync_error) {
          <fw-icon color="red" size="medium">warning-circle</fw-icon>
        }
      </div>
      @if (ldapStatus()?.last_success) {
        <p test-id="ldap-message">Last Sync: {{ldapStatus().last_success | date:'short'}}</p>
      }
      @else if(ldapStatus()?.last_attempt) {
        <p test-id="ldap-message">Last Attempt: {{ldapStatus().last_attempt | date:'short'}}</p>
      }
      @else {
        <p test-id="ldap-message">First sync pending...</p>
      }
    </div>
  </fw-popover>
}
